export const getHomeData = (instance) => {
  return instance()
    .get(`/general/api/v1/home/`)
    .then((response) => {
      return response?.data;
    });
};
export const getPendingOrderData = (instance) => {
  return instance()
    .get(`/fund/api/v1/pending-orders-count/`)
    .then((response) => {
      return response?.data;
    });
};
